import * as yup from 'yup'

export default yup.object().shape({
  name: yup.string().required('Campo obrigatório'),
  clientId: yup.number().nullable().required('Campo obrigatório'),
  requesterId: yup.number().required('Campo obrigatório'),
  assetIds: yup.array().of(
    yup.object().shape({
      id: yup.string().required('Campo obrigatório'),
    }),),
  analystIds: yup.array().of(
    yup.object().shape({
      id: yup.string().required('Campo obrigatório'),
    }),),
  description: yup.string().required('Campo obrigatório'),
})
